import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {cleanHexCode} from '../../../../mycourses/util'
import {DraftSpan} from '../CoursesSelector/CoursesSelector'

const SelectDropdown = styled.div`
  position: absolute;
  max-height: 250px;
  width: 555px;
  overflow: scroll;
  padding: 0 22px 16px;
  border-width: 0 0.5px 0.5px;
  border-style: solid;
  border-color: #BBBBBB;
  border-radius: 0 0 5px 5px;
  background-color: white;
  ul {
    padding-top: 18px;
    font-size: 11px;
    line-height: 13px;
    color: #666666
  }
  li {
    padding: 8px 22px;
    font-size: 14px;
    line-height: 16px;
    cursor: pointer;
    margin: 0 -22px;
    &:hover {
      background-color: rgba(222, 235, 255, 0.5);
    }
`

const JourneyDropdown = ({journeys, onSelectJourney, selectedJourney, toggle}) => {
  const handleSelectCourse = (journey) => {
    onSelectJourney(journey)
    toggle()
  }
  console.log('journeys in dropdown', journeys)
  return (
    <SelectDropdown>
      {journeys.map((academicYear) => {
        if (academicYear.courses.length > 0) {
          return <ul key={academicYear.id}>
            <p>{academicYear.name}</p>
            {academicYear.courses.map((journey) => (
              <li key={journey.id} style={{color: cleanHexCode(journey.master_course.color), backgroundColor: selectedJourney && (journey.id === selectedJourney.id) ? 'rgba(222, 235, 255, 0.75)' : ''}} onClick={() => handleSelectCourse(journey)}>
                {journey.grade_level_abbreviation}/ {journey.name}
                <DraftSpan>{!journey.marked_ready_for_enrollment_at ? '(Draft)' : ''}</DraftSpan>
              </li>
            ))}
          </ul>
        }
      })}
    </SelectDropdown>
    // <SelectDropdown>
    //   {journeys.map((journey) => {
    //     return (
    //       <ul key={journey.id}>
    //           <li key={journey.id} onClick={() => handleSelectCourse(journey)}>
    //             {journey.name}
    //           </li>
    //       </ul>
    //     )
    //   })}
    // </SelectDropdown>
  )
}

JourneyDropdown.propTypes = {
  journeys: PropTypes.array.isRequired
}

export default JourneyDropdown




// WEBPACK FOOTER //
// ./src/components/modal/CreateOrEditCourseModal/InputComponents/JourneySelector/JourneyDropdown.js